import script from "./ConfirmationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationStep.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationStep.vue?vue&type=style&index=0&id=77bbde78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77bbde78"]])

export default __exports__